const blocks = document.querySelectorAll(
  ".wp-block-adspire-ai-blog-author-sidebar"
);

if (blocks.length) {
  import("./view-frontend.js").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
